export const getUserProfile = state => state.users.profile;